import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { Row, Col, Button } from 'reactstrap';
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { useCookies } from 'react-cookie';
import FloatingControls from '../../components/FloatingControls';
import FormPageLayout from '../../components/FormPageLayout';
import LoadingOverlay from '../../components/LoadingOverlay';
import ErrorToast from '../../ErrorToast';
import { displayError } from '../../helpers';
import { getUserAllowedPlants } from '../../services/PlantServices';
import { createMaintenanceMonthlyCost } from '../../services/MaintenanceServices';
import { ALLOCATION_METHODS, COST_TYPES } from './maintenanceConstants';

function MaintenanceMonthlyCost() {
    const [cookies] = useCookies(['myToken']);
    const navigate = useNavigate();
    const [plants, setPlants] = useState([]);
    const [inProgress, setInProgress] = useState(false);
    const now = new Date();
    const [inputs, setInputs] = useState({
        plant_id: '',
        cost_year: now.getFullYear(),
        cost_month: now.getMonth() + 1,
        cost_type: 'EB',
        bill_amount: 0,
        bill_kwh: 0,
        allocation_method: 'BY_KWH',
        user_remarks: '',
    });

    useEffect(() => {
        getUserAllowedPlants(cookies).then((response) => {
            setPlants((response.plant_list || [])
                .filter((p) => p.status)
                .map((p) => ({ value: p.id, label: p.plant_alias })));
        });
    }, [cookies]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setInputs((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!inputs.plant_id) {
            Swal.fire('Plant is required.');
            return;
        }
        setInProgress(true);
        createMaintenanceMonthlyCost(cookies, {
            ...inputs,
            cost_year: Number(inputs.cost_year),
            cost_month: Number(inputs.cost_month),
            bill_amount: Number(inputs.bill_amount),
            bill_kwh: Number(inputs.bill_kwh),
        })
            .then((response) => {
                Swal.fire({ icon: 'success', title: 'Month-end cost saved' }).then(() => {
                    navigate(`/MaintenanceMonthlyCostEdit/${response.id}`);
                });
            })
            .catch((error) => displayError(error?.response?.data || error, 'Save Failed'))
            .finally(() => setInProgress(false));
    };

    return (
        <div id="outer-container" className="App">
            <Sidebar pageWrapId="page-wrap" outerContainerId="outer-container" />
            <ErrorToast />
            <LoadingOverlay active={inProgress} />
            <div id="page-wrap">
                <form onSubmit={handleSubmit}>
                    <FloatingControls
                        tableLink="/MaintenanceMonthlyCostTable"
                        formLink="/MaintenanceMonthlyCost"
                        addNewLabel="Main Form"
                        enableCancel
                        onCancel={() => navigate('/MaintenanceMonthlyCostTable')}
                    />
                    <FormPageLayout
                        moduleLabel="MAINTENANCE"
                        title="Month-End Costs"
                        subtitle="Enter EB bill, pump cost and other month-end amounts for KPI allocation."
                        modeLabel="CREATE MODE"
                    >
                        <div className="container form-control-panel">
                            <Row>
                                <Col xl={6} lg={12}>
                                    <div className="form-row table-bordered shadow p-2 my-2 border-secondary mb-3">
                                        <label className="form-group col-sm-4 text-right">Plant</label>
                                        <select name="plant_id" className="form-control col-sm-7 mandatory-form-control" value={inputs.plant_id} onChange={handleChange} required>
                                            <option value="">Select Plant</option>
                                            {plants.map((p) => (<option key={p.value} value={p.value}>{p.label}</option>))}
                                        </select>

                                        <label className="form-group col-sm-4 text-right">Year</label>
                                        <input type="number" name="cost_year" className="form-control col-sm-7" value={inputs.cost_year} onChange={handleChange} required />

                                        <label className="form-group col-sm-4 text-right">Month</label>
                                        <input type="number" min="1" max="12" name="cost_month" className="form-control col-sm-7" value={inputs.cost_month} onChange={handleChange} required />

                                        <label className="form-group col-sm-4 text-right">Cost Type</label>
                                        <select name="cost_type" className="form-control col-sm-7" value={inputs.cost_type} onChange={handleChange}>
                                            {COST_TYPES.map((item) => (<option key={item.value} value={item.value}>{item.label}</option>))}
                                        </select>

                                        <label className="form-group col-sm-4 text-right">Bill Amount ₹</label>
                                        <input type="number" step="0.01" name="bill_amount" className="form-control col-sm-7" value={inputs.bill_amount} onChange={handleChange} />

                                        <label className="form-group col-sm-4 text-right">Bill kWh</label>
                                        <input type="number" step="0.001" name="bill_kwh" className="form-control col-sm-7" value={inputs.bill_kwh} onChange={handleChange} />

                                        <label className="form-group col-sm-4 text-right">Allocation</label>
                                        <select name="allocation_method" className="form-control col-sm-7" value={inputs.allocation_method} onChange={handleChange}>
                                            {ALLOCATION_METHODS.map((item) => (<option key={item.value} value={item.value}>{item.label}</option>))}
                                        </select>

                                        <label className="form-group col-sm-4 text-right">Remarks</label>
                                        <input name="user_remarks" className="form-control col-sm-7" value={inputs.user_remarks} onChange={handleChange} />
                                    </div>
                                    <Button color="primary" type="submit">Save Month-End Cost</Button>
                                </Col>
                            </Row>
                        </div>
                    </FormPageLayout>
                </form>
            </div>
        </div>
    );
}

export default MaintenanceMonthlyCost;
